import { useDispatch } from "react-redux";
import { useSelectorTyped } from "../../../common/redux/store";
import { getAddMemberQuestions } from "./data/questions";
import { getDropdownChoicesForMembers } from "../../../utils/teams/surveyjs-helper";
import { IAddTeamMembersForm, TeamDetailsPageActions } from "../redux";
import { useState } from "react";
import castTo from "../../../utils/cast-to";
import { SurveyModel } from "survey-react";
import { ITeamCreateForm, TeamType } from "../../create-team/redux";
import { useSelectedNonGITSMembers } from "../../../common/hooks/teams/use-selected-non-gits-members";

export default function useAddTeamMembersController() {
  const addMembersModalShow = useSelectorTyped((state) => state.teamDetailsPage.showAddMembersModal);
  const addTeamMembersPE = useSelectorTyped((state) => state.teamDetailsPage.addTeamMembersPE);
  const potentialMembersPEV = useSelectorTyped((state) => state.teamsPage.potentialMembersPEV);

  const team = useSelectorTyped((state) => state.teamDetailsPage.teamDetailsPEV.value!);
  const [selectedMembersToBeAddedToTeam, setSelectedMembersToBeAddedToTeam] = useState(castTo<string[]>([]));
  const selectedNonGITSMembers = useSelectedNonGITSMembers(selectedMembersToBeAddedToTeam);

  const dispatch = useDispatch();
  const isAddMembersInProgress = !!addTeamMembersPE.progress;

  const getAddButtonLabel = () => isAddMembersInProgress ? "Adding" : "Add";

  const onCancel = () => {
    setSelectedMembersToBeAddedToTeam([]);
    dispatch(TeamDetailsPageActions.displayAddMembersModal(false));
  };

  const getFormData = () => ({ managers: [], developers: [], "non-developers": [] });

  const shouldDifferentiateNonGITSMembers
        = team.teamType !== TeamType.EXPERIMENT_AND_INNOVATION && team.teamType !== TeamType.SOFTWARE_MANAGEMENT;

  const questions = getAddMemberQuestions(
    getDropdownChoicesForMembers(potentialMembersPEV.value, shouldDifferentiateNonGITSMembers),
    team.teamType,
  );

  const shouldRenderForm = () => potentialMembersPEV.value
    && !potentialMembersPEV.progress
    && !potentialMembersPEV.error;

  const shouldRenderProgress = () => potentialMembersPEV.progress
    && potentialMembersPEV.value.length === 0;

  const shouldRenderError = () => potentialMembersPEV.error
    && !potentialMembersPEV.progress;

  return {
    addMembersModalShow,
    isAddMembersInProgress,
    getAddButtonLabel,
    getFormData,
    onCancel,
    questions,
    onAddButtonClick: (teamMembers: IAddTeamMembersForm) => {
      dispatch(TeamDetailsPageActions.addMembersToTheTeam({
        teamId: team.id,
        memberData: {
          managers: teamMembers.managers,
          developers: teamMembers.developers,
          "non-developers": teamMembers["non-developers"],
        },
      }));
      setSelectedMembersToBeAddedToTeam([]);
    },
    shouldRenderForm,
    shouldRenderProgress,
    shouldRenderError,
    shouldDifferentiateNonGITSMembers,
    NonGITSMembersAlertMessage: "Review your choices before you add members to the team!",
    handleFormValueChangedEvent: (form: SurveyModel) => {
      const formData = castTo<ITeamCreateForm>(form.data);
      const members = [
        ...(formData.managers ?? []),
        ...(formData.developers ?? []),
        ...(formData["non-developers"] ?? []),
      ];
      setSelectedMembersToBeAddedToTeam(members);
    },
    selectedNonGITSMembers,
    progressText: potentialMembersPEV.progress,
    errorText: potentialMembersPEV.error,
    shouldRenderNonGITSMembersAlert: () => shouldDifferentiateNonGITSMembers && (selectedNonGITSMembers.length > 0),
  };
}
